import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", {
            class: "text-normal-bold my-3",
            innerHTML: _ctx.title
        }, null, 8, _hoisted_1),
        _createElementVNode("div", {
            class: "text-center",
            innerHTML: _ctx.description
        }, null, 8, _hoisted_2)
    ], 64));
}
